// ── APP VERSION ───────────────────────────────────────────────────────────────
// Bump this manually on each release, or automate via CI.
// Format: MAJOR.MINOR.PATCH
//   MAJOR — breaking changes / major new features
//   MINOR — new features, backwards-compatible
//   PATCH — bug fixes, minor improvements
//
// Release names follow UK gym / fitness landmarks (alphabetical per major version)

export const APP_VERSION   = "1.0.3";
export const RELEASE_NAME  = "Barbican";       // current release name
export const RELEASE_DATE  = "2026-04-14";

export const CHANGELOG = [
  {
    version: "1.0.3",
    name: "Barbican",
    date: "2026-04-14",
    notes: [
      "Supabase database integration — data now persists across sessions",
      "Superuser admin panel added",
      "Paywall with 2-month free trial and annual plans",
      "Input box-sizing fix for mobile browsers",
    ],
  },
  {
    version: "1.0.2",
    name: "Archway",
    date: "2026-03-28",
    notes: [
      "Session plan viewing for clients (upcoming & past)",
      "Exercise drill-down with YouTube video embed",
      "Inline plan editing within session bookings",
      "Rebook status on completed sessions",
    ],
  },
  {
    version: "1.0.1",
    name: "Aldgate",
    date: "2026-03-10",
    notes: [
      "Sets / reps / kg / rest editable per exercise in fitness plans",
      "Next session derived from live session data",
      "Future seed dates for demo data",
    ],
  },
  {
    version: "1.0.0",
    name: "Angel",
    date: "2026-02-01",
    notes: [
      "Initial release",
      "PT dashboard, client management, session booking",
      "Fitness plans, exercise library, messaging",
      "Client portal with session history",
    ],
  },
];

// ── MOBILE APP ────────────────────────────────────────────────────────────────
// Release names are chosen by you — update MOBILE_NAME with each new release.
export const MOBILE_VERSION  = "1.0.0";
export const MOBILE_NAME     = "Genesis";
export const MOBILE_DATE     = "2026-04-14";
